module.exports = __webpack_public_path__ + "img/32.aab165ed.png";